import React from "react";
import { Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { ChangeDateFormat } from "../../Common/Helpers/ChangeDateFormat";
import { API_KEY_STATUS, apiKeyStatusLabel } from "../Models/Response/ResponseApiKey";

/**
 * Read-only details of an API key (the key itself is never shown again).
 */
const ApiKeyInfo = ({ apiKey }) => {
    const { t } = useTranslation();

    if (!apiKey) return null;

    const statusClass = apiKey.status === API_KEY_STATUS.ACTIVE
        ? 'box-green'
        : apiKey.status === API_KEY_STATUS.REVOKED ? 'box-red' : 'box-custom-grey';

    const rows = [
        { label: t('apiKey.name'), value: apiKey.name },
        { label: t('apiKey.prefix'), value: apiKey.prefix ? <code>{`${apiKey.prefix}…`}</code> : '' },
        { label: t('modelLabel.status'), value: <span className={`${statusClass} reimbursement-status-pill-auto`}>{apiKeyStatusLabel(apiKey.status)}</span> },
        { label: t('apiKey.expiresAt'), value: apiKey.expiresAt ? ChangeDateFormat('date', apiKey.expiresAt) : t('apiKey.never') },
        { label: t('apiKey.lastUsedAt'), value: apiKey.lastUsedAt ? ChangeDateFormat('dateTime', apiKey.lastUsedAt) : t('apiKey.neverUsed') },
        { label: t('apiKey.createdByName'), value: apiKey.createdByName },
        { label: t('modelLabel.createdAt'), value: apiKey.createdAt ? ChangeDateFormat('dateTime', apiKey.createdAt) : '' },
    ];

    if (apiKey.revokedAt) {
        rows.push({ label: t('apiKey.revokedAt'), value: ChangeDateFormat('dateTime', apiKey.revokedAt) });
        rows.push({ label: t('apiKey.revokedByName'), value: apiKey.revokedByName });
    }

    return (
        <Row className="select-org-panel-wrapper mx-0">
            {rows.map((row) => (
                <Col lg={12} key={row.label} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                    <span className="text-muted">{row.label}</span>
                    <span className="fw-semibold text-end ps-3">{row.value}</span>
                </Col>
            ))}
        </Row>
    );
};

export default ApiKeyInfo;
